const history = {
    id: "history",
    title: "History",
    coverImage: "history/history.jpg",
    description: "Stories etched in time.",
    order: 1,
    orientation: "landscape",

    images: [
        {
            src: "history/IMG_9268.jpg",
            title: "Pillars of Athena",
            description: "Thousands of years of history in Jerash"
        },
        {
            src: "history/IMG_9240.jpg",
            title: "Intricate Designs.",
            description: "Ancient city of Jerash"
        },
        {
            src: "history/IMG_9284.jpg",
            title: "A peek into the past.",
            description: "Sunset in Jerash"
        },
        {
            src: "history/IMG_9314.jpg",
            title: "The columns of the Empire",
            description: "It still stands tall in Jerash"
        },
        {
            src: "history/IMG_9316.jpg",
            title: "Another view of the columns",
            description: "in Jerash."
        },
        {
            src: "history/IMG_9328.jpg",
            title: "Ruins of an Empire",
            description: "in Jerash"
        }
    ]
};

export default history;